export default __webpack_public_path__ + "static/media/119.a034cd94.jpg";